import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import request from '@/modules/base/util/request'

import AccountSettingProvider from '@/modules/settings/components/tax-settings/services/account-setting-provider'
import GrossNetSwitch from './gross-net-switch'

import { fetchCompanyData } from '@/redux/ducks/settings/company'
import useClientSetting from '@/modules/client/_helpers/useClientSetting'

const httpClient = {
  post: (url, options) => {
    return request(url, { ...options, method: 'POST' })
  },
}

const GrossNetSwitchWrapper = () => {
  const dispatch = useDispatch()
  const { client } = useClientSetting()

  const [data, setData] = useState(null)

  const companyData = useSelector(store => store.settings.company)

  useEffect(() => {
    dispatch(fetchCompanyData())
  }, [])

  useEffect(() => {
    setData(companyData)
  }, [companyData])

  if (!data) return null

  return (
    <AccountSettingProvider http={httpClient} initData={data} collaborationId={client?.id}>
      <GrossNetSwitch />
    </AccountSettingProvider>
  )
}

export default GrossNetSwitchWrapper
